import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';

import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
// import useWindowDimensions from '../component/Dimension';

// const useStyles1 = makeStyles(() => ({
//     root: {
//       maxWidth: 304,
//       margin: 'auto',
//     },
//     content: {
//       padding: 24,
//     },
//     avatar: {
//         position:'absolute',
//         marginTop:'-3%',
//         marginLeft:'12%',
//       width: 50,
//       height: 50,
//       border: '2px solid #fff',
//       margin: '-48px 32px 0 auto',
//       '& > img': {
//         margin: 0,
//       },
//     },
//   }));

export default function HotelBedsDetails(props) {

//   const cardStyles = useStyles1();
//   const shadowStyles = useSoftRiseShadowStyles();
//   const textCardContentStyles = useN01TextInfoContentStyles();
//   const { height, width } = useWindowDimensions();
  //console.log(width,height);
  return (
        <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Customer Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Title</TableCell>
                    <TableCell>First Name</TableCell>
                    <TableCell>Last Name</TableCell>
                    <TableCell>Type</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {
                        props.data.booking.hotel.rooms.map((item,index)=>{

                            return item.paxes.map((items, keys)=>{
                                return <TableRow  key={keys}>
                                        <TableCell component="th" scope="row">
                                            "Mr/Mrs"
                                        </TableCell>
                                        <TableCell>{items.name}</TableCell>
                                        <TableCell>{items.surname}</TableCell>
                                        <TableCell>{items.type == 'AD'?"Adult":"Child"}</TableCell>
                                    </TableRow>
                            })

                        })
                    }
                    
                </TableBody>
              </Table>
            </Box>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Room Details
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Total Fare</TableCell>
                    <TableCell>Inclusion</TableCell>
                  </TableRow>
                </TableHead>
                 <TableBody>
                    {
                        props.data.booking.hotel.rooms.map((items,keys)=>{   
                        return <TableRow  key={keys}>
                                <TableCell component="th" scope="row">
                                    {items.name}
                                </TableCell>
                                <TableCell>{parseFloat(items.rates[0].net) + (parseFloat(items.rates[0].net) * parseFloat(props.data.commission))/100} {props.data.booking.hotel.currency}</TableCell>
                                <TableCell>{items.rates[0].boardName}</TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
              </Table>
            </Box>
        </TableCell>
      </TableRow>
  );
}


// WEBPACK FOOTER //
// ./src/Pages/HotelBedsDetails.js